import React, { useContext, useState, useEffect } from "react";
import HeadingBanner from "../../Components/HeadingBanner.jsx";
import Dashboard from "../../Components/Dashboard.jsx";
import { Logindetail } from "../../context/Logindetail.js";
import toast from "react-hot-toast";
import axios from "axios";
import { FaRegClock } from "react-icons/fa";

const Encashment = ({ settings }) => {
    const { token } = useContext(Logindetail);

    // Form inputs and steps
    const [couponId, setCouponId] = useState("");
    const [step, setStep] = useState(1); // 1 = Enter ID, 2 = Enter details

    // Details for Step 2
    const [paymentMethod, setPaymentMethod] = useState("gpay"); // "gpay" or "bank"
    const [upiId, setUpiId] = useState("");
    const [upiPhone, setUpiPhone] = useState("");
    const [bankDetails, setBankDetails] = useState({
        bankName: "",
        ifsc: "",
        accountNumber: "",
        name: "",
        mobileNumber: ""
    });

    const [couponDetails, setCouponDetails] = useState(null);
    const [encashmentList, setEncashmentList] = useState([]);

    const fetchList = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}enhancement_list`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res?.data?.data) {
                setEncashmentList(res.data.data);
            } else if (Array.isArray(res?.data)) {
                setEncashmentList(res.data);
            }
        } catch (error) {
            console.error("Failed to fetch encashment list", error);
        }
    };

    useEffect(() => {
        if (token) fetchList();
    }, [token]);

    const handleCancelClick = async () => {
        if (!couponId.trim()) {
            return toast.error("Please enter a valid coupon ID");
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}enhance_coupon_check`, {
                params: { generate_coupon_code: couponId },
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response?.data?.result === false) {
                return toast.error(response?.data?.message || "Invalid coupon code!");
            }

            const data = response?.data?.data || {};
            setCouponDetails(data);
            toast.success(response?.data?.message || "Valid coupon!");
            setStep(2);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Failed to verify coupon");
        }
    };

    const handleProceed = async () => {
        if (paymentMethod === "gpay") {
            if (!upiId.trim() || !upiPhone.trim()) {
                return toast.error("Please enter both UPI ID and Phone Number");
            }
        }
        if (paymentMethod === "bank") {
            if (!bankDetails.bankName || !bankDetails.ifsc || !bankDetails.accountNumber || !bankDetails.name || !bankDetails.mobileNumber) {
                return toast.error("Please fill all bank details");
            }
        }

        try {
            const payload = {
                code: couponId,
                payment_type: paymentMethod,
                amount: couponDetails?.total_amount || 0,
                tax: couponDetails?.coupon_discount || 0,
                total: couponDetails?.total_after_discount || 0,
                gpay_upi_id: paymentMethod === "gpay" ? upiId : null,
                gpay_phone_number: paymentMethod === "gpay" ? upiPhone : null,
                bank_name: paymentMethod === "bank" ? bankDetails.bankName : null,
                bank_account_number: paymentMethod === "bank" ? bankDetails.accountNumber : null,
                bank_ifsc_code: paymentMethod === "bank" ? bankDetails.ifsc : null,
                bank_beneficiary_name: paymentMethod === "bank" ? bankDetails.name : null,
                bank_phone_number: paymentMethod === "bank" ? bankDetails.mobileNumber : null
            };

            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}enhancement`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response?.data?.result === false) {
                return toast.error(response?.data?.message || "Failed to submit request");
            }

            toast.success(response?.data?.message || "Encashment request submitted successfully!");
            // Reset state
            setStep(1);
            setCouponId("");
            setUpiId("");
            setUpiPhone("");
            setBankDetails({ bankName: "", ifsc: "", accountNumber: "", name: "", mobileNumber: "" });
            setPaymentMethod("gpay");
            setCouponDetails(null);

            fetchList();

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Failed to submit encashment request");
        }
    };


    return (
        <>
            <HeadingBanner title={"Encashment Coupon"} />
            <section>
                <div className="container">
                    <div className="mybankac-layout">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4">
                                <Dashboard setting_data={settings} />
                            </div>

                            <div className="col-xl-9 col-lg-8">
                                <div className="card shadow-sm p-4 rounded bg-white">
                                    <h4 className="mb-4">Encashment Coupon</h4>

                                    {step === 1 && (
                                        <div className="form-group col-12 w-100 col-md-8">
                                            <label className="fw-bold mb-2">Enter Coupon ID</label>
                                            <input
                                                type="text"
                                                className="form-control w-50"
                                                placeholder="e.g. JDSWVG2DNF"
                                                value={couponId}
                                                onChange={(e) => setCouponId(e.target.value)}
                                            />

                                            <div className="mt-4">
                                                <button
                                                    className="btn btn-danger w-50 py-2 fw-bold"
                                                    onClick={handleCancelClick}
                                                >
                                                    Verify & Encash
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {step === 2 && (
                                        <div className="form-group col-12 w-100 col-md-8">
                                            {/* Details Breakdown */}
                                            {couponDetails && (
                                                <div className="mb-4 p-3 bg-light rounded text-dark">
                                                    <h6 className="fw-bold">Coupon Summary</h6>
                                                    <div className="d-flex justify-content-between">
                                                        <span>Code:</span> <span>{couponId}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span>Total Amount:</span> <span>₹ {Number(couponDetails?.total_amount || 0).toFixed(2)}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span>Service Charges:</span> <span className="text-danger">- ₹ {Number(couponDetails?.coupon_discount || 0).toFixed(2)}</span>
                                                    </div>
                                                    <hr className="my-2" />
                                                    <div className="d-flex justify-content-between fw-bold">
                                                        <span>You Will Get:</span> <span className="text-success">₹ {Number(couponDetails?.total_after_discount || 0).toFixed(2)}</span>
                                                    </div>
                                                </div>
                                            )}

                                            <h5 className="mb-3 text-secondary">Select Transfer Method</h5>

                                            <select
                                                className="form-select mb-4 w-50"
                                                value={paymentMethod}
                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                            >
                                                <option value="gpay">UPI / GPay</option>
                                                <option value="bank">Bank Details</option>
                                            </select>

                                            {paymentMethod === "gpay" ? (
                                                <div className="mb-3 w-100 row g-3">
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-2">Enter UPI ID</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="e.g. mobile@upi"
                                                            value={upiId}
                                                            onChange={(e) => setUpiId(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-2">Phone Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Phone Number"
                                                            value={upiPhone}
                                                            onChange={(e) => setUpiPhone(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row g-3 w-100">
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-1">Bank Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Bank Name"
                                                            value={bankDetails.bankName}
                                                            onChange={(e) => setBankDetails({ ...bankDetails, bankName: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-1">Account Holder Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Beneficiary Name"
                                                            value={bankDetails.name}
                                                            onChange={(e) => setBankDetails({ ...bankDetails, name: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-1">Account Number</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Account Number"
                                                            value={bankDetails.accountNumber}
                                                            onChange={(e) => setBankDetails({ ...bankDetails, accountNumber: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-1">IFSC Code</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="e.g. SBIN0001234"
                                                            value={bankDetails.ifsc}
                                                            onChange={(e) => setBankDetails({ ...bankDetails, ifsc: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fw-bold mb-1">Mobile Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Mobile Number"
                                                            value={bankDetails.mobileNumber}
                                                            onChange={(e) => setBankDetails({ ...bankDetails, mobileNumber: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mt-4 d-flex gap-2">
                                                <button
                                                    className="btn btn-secondary py-2 px-4 fw-bold"
                                                    onClick={() => setStep(1)}
                                                >
                                                    Back
                                                </button>
                                                <button
                                                    className="btn btn-success py-2 px-5 fw-bold"
                                                    onClick={handleProceed}
                                                >
                                                    Proceed
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </div>

                                {/* Encashment List */}
                                <div className="card shadow-sm p-4 rounded mt-4">
                                    <h5 className="mb-3">My Encashment Requests</h5>

                                    <div className="row g-3">
                                        {encashmentList?.length === 0 ? (
                                            <div className="col-12 text-center text-muted">No encashments found</div>
                                        ) : (
                                            encashmentList?.map((encash) => {
                                                const createdAt = encash.created_at;
                                                const dateObj = new Date(createdAt);

                                                const formattedDateTime = `${dateObj.getDate().toString().padStart(2, "0")}-${(dateObj.getMonth() + 1)
                                                    .toString()
                                                    .padStart(2, "0")}-${dateObj.getFullYear()}`;

                                                // reuse===1 = Rejected, status===1 = Approved, else Pending
                                                const isRejected = encash?.reuse === 1;
                                                const isApproved = encash?.status === 1 && !isRejected;
                                                const badgeClass = isRejected ? 'bg-danger' : isApproved ? 'bg-success' : 'bg-warning';
                                                const badgeLabel = isRejected ? 'Rejected' : isApproved ? 'Approved' : 'Pending';

                                                return (
                                                    <div key={encash?.id} className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                        <div
                                                            className="p-3 border rounded h-100"
                                                            style={isRejected ? { borderColor: "#f5c2c7", backgroundColor: "#fff8f8" } : {}}
                                                        >
                                                            <div className="d-flex justify-content-between">
                                                                <h6 className="mb-2 fw-bold">{encash.name}</h6>
                                                                <span className={`badge ${badgeClass} my-auto`}>
                                                                    {badgeLabel}
                                                                </span>
                                                            </div>

                                                            <p className="mb-1 text-secondary" style={{ fontSize: "14px" }}>
                                                                Original Amount: <b>₹{Number(encash?.grand_total).toFixed(2)}</b>
                                                            </p>
                                                            <p className="mb-1 text-secondary" style={{ fontSize: "14px" }}>
                                                                Service Charges: <b>₹{Number(encash?.gst).toFixed(2)}</b>
                                                            </p>
                                                            <p className="mb-1 fw-bold text-success">
                                                                Received Amount: <b>₹{Number(encash?.total_amount).toFixed(2)}</b>
                                                            </p>

                                                            {/* ✅ Rejected Status Block */}
                                                            {/* {isRejected && (
                                                                <div
                                                                    className="mt-2 p-2 rounded"
                                                                    style={{ backgroundColor: "#fde8e8", border: "1px solid #f5c2c7" }}
                                                                >
                                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                                        <span
                                                                            className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                                                                            style={{ backgroundColor: "#dc3545", width: "18px", height: "18px", fontSize: "10px", flexShrink: 0 }}
                                                                        >✕</span>
                                                                        <p className="mb-0 fw-bold text-danger" style={{ fontSize: "12px" }}>
                                                                            Request Rejected
                                                                        </p>
                                                                    </div>
                                                                    {encash?.response_message && (
                                                                        <p className="mb-0 text-danger ps-1" style={{ fontSize: "12px", paddingLeft: "26px" }}>
                                                                            <span className="fw-semibold">Reason: </span>{encash.response_message}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            )} */}

                                                            <div className="d-flex flex-column mt-3 text-muted" style={{ fontSize: "12px" }}>
                                                                <div className="d-flex align-items-center gap-1">
                                                                    <FaRegClock size={12} />
                                                                    <span>Requested: {formattedDateTime}</span>
                                                                </div>
                                                                {encash?.payment_type && (
                                                                    <div className="mt-1">
                                                                        Method: <span className="text-uppercase text-dark fw-bold">{encash?.payment_type}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Encashment;